import {
  takeLatest, cancel, put,
} from 'redux-saga/effects';

import Analytics from 'app/lib/Analytics/Analytics';
import * as giftActions from '../actions';

export const config = {
  action: giftActions.useGiftSuccess.type,
  method: takeLatest,
};

export function* func(action: giftActions.IModalUseGiftSuccessPayload) {
  yield put(giftActions.setLoadingGift(false));
  if (!action?.payload?.url) {
    yield cancel(); return;
  }
  yield put(giftActions.resetGift());
  Analytics.track().giftCardPageRedeemWasTappedForward();
  // window.open(action.payload.url, '_blank', 'noreferrer');
  document.location.href = action.payload.url;
}
